"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultManagementFinalClaimSchema = void 0;
exports.defaultManagementFinalClaimSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        errorMessage: '- should not have additional property ${0#}',
    },
    required: ['toolAppliedFlag'],
    properties: {
        approvedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        toolAppliedFlag: {
            type: ['boolean', 'string'],
            enum: [true, false, 'true', 'false'],
            errorMessage: 'should be boolean',
        },
        toolDescription: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 1000,
            errorMessage: 'should be a string with maximum of 1000 characters or null',
        },
    },
};
